import { render, staticRenderFns } from "./PageEditor.vue?vue&type=template&id=27482972&scoped=true"
import script from "./PageEditor.js?vue&type=script&lang=js&external"
export * from "./PageEditor.js?vue&type=script&lang=js&external"
import style0 from "./PageEditor.scss?vue&type=style&index=0&id=27482972&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27482972",
  null
  
)

export default component.exports